import { render } from "./FormatButton.vue?vue&type=template&id=01810079"
import script from "./FormatButton.vue?vue&type=script&lang=js"
export * from "./FormatButton.vue?vue&type=script&lang=js"

import "./FormatButton.vue?vue&type=style&index=0&id=01810079&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__